module.exports = __webpack_public_path__ + "img/bz.4ea47f02.png";